import { useTheme } from './theme/useTheme';

export type ThemeProps = {
  fontDefaultLh: number;
  spacers: { [key: string]: number };
  tableCellHorizontalPadding: number;
  iconButtonWidth: number;
  tableCellVerticalPadding: number;
  checkboxButtonSize: number;
  chart: ChartTheme;
  dataTableRowHeight: number;
  dataTableHeaderHeight: number;
  scrollbarWidth: number;
  tile: TileTheme;
  finalTableHeaderActionsSize: number;
  finalTableGroupDepthPadding: number;
  finalTableGroupExpColWidth: number;
};
export type ChartTheme = {
  dangerColor: string;
  warningColor: string;
  successColor: string;
  donutProgressEmptyColor: string;
};
export type TileTheme = {
  width: number;
  height: number;
};

export const useCurrentTheme = (): ThemeProps => {
  const theme = useTheme();
  return themes[theme.theme || 'ui-default'];
};

export const themes: { [key: string]: ThemeProps } = {
  'ui-default': {
    fontDefaultLh: 18,
    scrollbarWidth: 10,
    spacers: {
      '0': 0,
      '1': 7,
      '2': 14,
      '3': 21,
      '4': 28,
      '5': 35,
    },
    iconButtonWidth: 28,
    tableCellVerticalPadding: 5,
    tableCellHorizontalPadding: 14,
    checkboxButtonSize: 28,
    dataTableRowHeight: 28,
    dataTableHeaderHeight: 28,
    chart: {
      dangerColor: '#eb2323',
      warningColor: '#f59f1e',
      successColor: '#52c41a',
      donutProgressEmptyColor: '#C9D5ED',
    },
    tile: {
      width: 85,
      height: 85,
    },
    finalTableHeaderActionsSize: 22,
    finalTableGroupDepthPadding: 24,
    finalTableGroupExpColWidth: 32,
  },
  'ui-legacy-v3': {
    fontDefaultLh: 18,
    scrollbarWidth: 17,
    spacers: {
      '0': 0,
      '1': 7,
      '2': 14,
      '3': 21,
      '4': 28,
      '5': 35,
    },
    iconButtonWidth: 28,
    tableCellVerticalPadding: 5,
    tableCellHorizontalPadding: 14,
    checkboxButtonSize: 28,
    dataTableRowHeight: 48,
    dataTableHeaderHeight: 32,
    chart: {
      dangerColor: '#eb2323',
      warningColor: '#f59f1e',
      successColor: '#60c718',
      donutProgressEmptyColor: '#C9D5ED',
    },
    tile: {
      width: 40,
      height: 40,
    },
    finalTableHeaderActionsSize: 22,
    finalTableGroupDepthPadding: 24,
    finalTableGroupExpColWidth: 32,
  },
};
